import _ from 'lodash';

function getScope(property) {
    let scope = _.get(property, 'info.mowing_preferences.scope');
    if (scope === 'frontonly' || scope === 'backonly') {
        scope = scope === 'frontonly' ? 'Front-yard only' : 'Backyard only';
    } else {
        scope = null;
    }

    return scope;
}

// eslint-disable-next-line import/prefer-default-export
export const lsPropertyHelpers = {
    getScope,
};
